import { render, staticRenderFns } from "./OrganizHome.vue?vue&type=template&id=a90541f8&scoped=true&"
import script from "./OrganizHome.vue?vue&type=script&scoped=true&lang=js&"
export * from "./OrganizHome.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./OrganizHome.vue?vue&type=style&index=0&id=a90541f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90541f8",
  null
  
)

export default component.exports